//BookClubBookMembers.jsx 
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const BookClubBookMembers = () => {

  const location = useLocation();
  const bookId = location.state.bookId;
  const clubId = location.state.clubId;
  const bookTitle = location.state.bookTitle;
  const bookClubTitle = location.state.bookClubTitle;
  
  // console.log("Location in bookId clubId", bookId, clubId);
  const authState = useSelector(state => state.authReducer);

  const [bookClubBookMembers, setBookClubBookMembers] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [selectedBookClubBookMemberId, setSelectedBookClubBookMemberId] = useState(null);

  const fetchBookClubBookMembers = useCallback(() => {

    const config = {
      url: "/bookclubmembers/bookmembers",
      method: "post",
      headers: { Authorization: authState.token },
      data: {clubId: clubId, bookId: bookId},
    };

    fetchData(config, { showSuccessToast: false })
      .then(data => {
        if (data && Array.isArray(data)) {
          setBookClubBookMembers(data);
        } else {
          console.error("Invalid response format: BookClub Book Members not found in response!");
        }
      })
      .catch(error => {
        console.error('Error fetching BookClub Book Members:', error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchBookClubBookMembers();
  }, [authState.isLoggedIn, fetchBookClubBookMembers]);

  const handleView = (bookClubBookMemberId) => {
    setSelectedBookClubBookMemberId(prevId => (prevId === bookClubBookMemberId ? null : bookClubBookMemberId));
  };

  const handleComments = (id) => {
    setSelectedRecordId(id);
  };

  const handleCommentSave = (id) => {
    setSelectedRecordId(id);
  };

  const formatDate = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const sortedBookClubBookMembers = [...bookClubBookMembers].sort((a, b) => b.memberName - a.memebrName);

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Book Club Book Members - List</h2>
      </div>
      <div className="my-2 mx-auto max-w-[700px] py-4">
        <div className="border border-gray-300 p-4 mt-4">
          <div className="flex justify-between items-center border-b border-b-gray-300 bg-purple-600">
            <div className='text-xl mt-1 mx-2  text-white w-7/10'>
              <p className='text-yellow-300' >There are {bookClubBookMembers.length} Active Members in {bookClubTitle} for {bookTitle}</p>
            </div>
          </div>
          {loading ? (
            <div className="spinner-container">
              <div className="spinner">
                <FontAwesomeIcon icon={faSpinner} spin />
              </div>
            </div>
          ) : (
            <div>
              {bookClubBookMembers.length === 0 ? (
                <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                  <span>No record found!!</span>
                </div>
              ) : (
                sortedBookClubBookMembers.map((bookClubBookMember, index) => (
                  <div key={bookClubBookMember._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                    <div className='flex'>
                      <span className='font-medium'>{index + 1}. {bookClubBookMember.memberName}</span>
                      <Tooltip text={"View details"} position={"top"}>
                        <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(bookClubBookMember._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </span>
                      </Tooltip>
                      {/* <Tooltip text={"Edit this record"} position={"top"}>
                        <Link to={`/bookclub/${bookClub._id}`} className='mr-4 text-green-600 cursor-pointer'>
                          <i className="fa-solid fa-pen"></i>
                        </Link>
                      </Tooltip> */}
                    </div>
                    
                    {selectedBookClubBookMemberId === bookClubBookMember._id && (
                      <div className='bg-gray-200 text-black'>
                        <div>
                          <div>
                            <p><strong>Club Name: </strong>{bookClubBookMember.clubName}</p>
                            <p><strong>Book Title: </strong>{bookClubBookMember.bookTitle}</p>
                            <p><strong>Remarks: </strong>{bookClubBookMember.remarks}</p>
                          </div>
                          <div>
                            <p className='text-blue-500'><strong>Member Info</strong></p>
                            <p><strong>Name:</strong> {bookClubBookMember.memberName}</p>
                            <p><strong>Joining Date:</strong> {bookClubBookMember.memberSince}</p>
                            <p><strong>Can Comment:</strong> {bookClubBookMember.canComment ? "Yes" : "No"}</p>
                          </div>
                          <div>
                            <p className='text-blue-500'><strong>Comments:</strong></p>
                            <div>
                              {bookClubBookMember.comments.map((comment, commentIndex) => (
                                <div key={commentIndex} className={commentIndex % 2 === 0 ? 'bg-blue-100' : ''}>
                                  <p><strong>{comment.commentBy}</strong></p>
                                  <p>{new Date(comment.date).toLocaleString()}</p>
                                  <p>{comment.comment}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  )
}

export default BookClubBookMembers;
